export default function BlogSection() {
  const blogPosts = [
    {
      id: 1,
      title: "Working on My eXp Team: Why Joining Jeffery Long's eXp Realty Group Is the Best Career Move for Real Estate Agents in California",
      author: "Jeffery Long",
      date: "May 30 2025",
      comments: 0,
      excerpt: "The real estate industry in the United States is evolving faster than ever. Technology, shifting consumer expectations, and new brokerage models are reshaping how agents build their careers. Discover why joining Jeffery Long's eXp Realty team offers the best commission splits, revenue sharing, stock awards, and mentorship...",
      slug: "working-on-my-exp-team",
      image: "https://public.readdy.ai/ai/img_res/a39e321b8f989cc98b5611e33150ec20.jpg"
    },
    {
      id: 2,
      title: "Discovering the Best Realtor in California: Why Jeffery Long Stands Out in the USA Real Estate Market",
      author: "Jeffery Long",
      date: "May 28 2025",
      comments: 0,
      excerpt: "In the vast and competitive world of real estate, finding the best realtor in the USA can feel like searching for a needle in a haystack. With countless agents vying for attention, how do you identify someone who truly excels? If you're specifically looking for the best realtor in California...",
      slug: "discovering-best-realtor-california-jeffery-long-stands-out-usa-real-estate-market",
      image: "https://readdy.ai/api/search-image?query=Stunning%20California%20luxury%20home%20exterior%20with%20beautiful%20landscaping%20palm%20trees%20and%20modern%20architecture%20showcasing%20premium%20real%20estate%20property%20in%20golden%20hour%20sunlight%20with%20clear%20blue%20sky%20and%20manicured%20gardens%20representing%20top%20tier%20residential%20market&width=600&height=300&seq=blog-post-luxury-002&orientation=landscape"
    },
    {
      id: 3,
      title: "Top Ten Services a Realtor Can Provide to Sell a Customer's House",
      author: "Jeffery Long",
      date: "May 25 2025",
      comments: 0,
      excerpt: "Top Ten Services a Realtor Can Provide to Sell a Customer's House. Pricing the Home Accurately. A realtor's top job is setting the right price. In Cameron Park, where home values can vary...",
      slug: "top-ten-services-realtor-can-provide-sell-customers-house",
      image: "https://readdy.ai/api/search-image?query=Real%20estate%20agent%20presenting%20home%20staging%20services%20with%20professional%20photography%20equipment%20tablet%20showing%20property%20listings%20and%20marketing%20materials%20in%20beautifully%20staged%20living%20room%20with%20modern%20furniture%20and%20elegant%20decor%20demonstrating%20seller%20services&width=600&height=300&seq=blog-post-services-003&orientation=landscape"
    },
    {
      id: 4,
      title: "Buying Homeowner Insurance in Cameron Park",
      author: "Jeffery Long",
      date: "May 23 2025",
      comments: 0,
      excerpt: "Navigating Homeowner Insurance in Cameron Park: Your Ultimate Guide. Buying homeowner insurance in Cameron Park, California, isn't just about checking a box—it's about protecting...",
      slug: "buying-homeowner-insurance-cameron-park",
      image: "https://readdy.ai/api/search-image?query=Charming%20family%20home%20in%20Cameron%20Park%20California%20with%20insurance%20protection%20concept%20showing%20safe%20secure%20residential%20property%20with%20beautiful%20curb%20appeal%20green%20lawn%20trees%20and%20peaceful%20suburban%20neighborhood%20setting%20representing%20homeowner%20security%20and%20coverage&width=600&height=300&seq=blog-post-insurance-004&orientation=landscape"
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-light mb-2">Latest Blog Posts</h1>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {blogPosts.map((post) => (
            <article key={post.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-48 bg-gradient-to-r from-teal-500 to-teal-600 flex items-center justify-center">
                <img 
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              
              <div className="p-6">
                <header className="mb-4">
                  <h2 className="text-xl font-semibold mb-3 line-clamp-2 hover:text-teal-600 transition-colors">
                    <a href={`/blog/${post.slug}`} className="cursor-pointer">
                      {post.title}
                    </a>
                  </h2>
                  
                  <div className="flex flex-wrap items-center text-sm text-gray-600 space-x-4">
                    <span>
                      Posted by <a href="/agents" className="text-teal-600 hover:text-teal-700">{post.author}</a>
                    </span>
                    <span className="flex items-center">
                      <i className="fa fa-calendar mr-1"></i>
                      {post.date}
                    </span>
                    <span className="flex items-center">
                      <i className="fa fa-comment mr-1"></i>
                      <a href={`/blog/${post.slug}#comments`} className="text-teal-600 hover:text-teal-700">
                        {post.comments} comments
                      </a>
                    </span>
                  </div>
                </header>
                
                <div className="mb-4">
                  <p className="text-gray-700 line-clamp-3">
                    {post.excerpt}
                  </p>
                </div>
                
                <footer>
                  <a 
                    href={`/blog/${post.slug}`}
                    className="inline-flex items-center text-teal-600 hover:text-teal-700 font-medium transition-colors"
                  >
                    Read More <i className="fa fa-chevron-right ml-1"></i>
                  </a>
                </footer>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-12">
          <a 
            href="/blog"
            className="inline-block bg-teal-600 text-white px-8 py-3 rounded-md hover:bg-teal-700 transition-colors font-medium whitespace-nowrap"
          >
            View All Blog Posts
          </a>
        </div>
      </div>
    </section>
  );
}